export const environment = {
  production: true,
  baseUrl: 'https://api.studentsrunphilly.org/api/v2/',
  invitationUrl : 'https://coursemap.studentsrunphilly.org/#/register/',
  invitationLeaderUrl :  'https://coursemap.studentsrunphilly.org/#/leader-register/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts